/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Debt_Fill_Action_MaxInputs */

const vi_lot_debt_fill_action_max = /** @type {(inputs: Lot_Debt_Fill_Action_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bù hết`)
};

/**

* @param {Lot_Debt_Fill_Action_MaxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_action_max = /** @type {((inputs?: Lot_Debt_Fill_Action_MaxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_Action_MaxInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_action_max(inputs)
});